export const campaignLanguageStrings = {
  None: _TL_('Use my campaign settings'),
  Albanian: _TL_('Albanian'),
  Arabic: _TL_('Arabic'),
  Bosnian: _TL_('Bosnian'),
  Bulgarian: _TL_('Bulgarian'),
  Croatian: _TL_('Croatian'),
  Czech: _TL_('Czech'),
  Danish: _TL_('Danish'),
  Dutch: _TL_('Dutch'),
  English: _TL_('English'),
  Estonian: _TL_('Estonian'),
  Finnish: _TL_('Finnish'),
  French: _TL_('French'),
  German: _TL_('German'),
  Greek: _TL_('Greek'),
  Hungarian: _TL_('Hungarian'),
  Icelandic: _TL_('Icelandic'),
  Italian: _TL_('Italian'),
  Japanese: _TL_('Japanese'),
  Latvian: _TL_('Latvian'),
  Lithuanian: _TL_('Lithuanian'),
  Macedonian: _TL_('Macedonian'),
  Maltese: _TL_('Maltese'),
  Norwegian: _TL_('Norwegian'),
  Polish: _TL_('Polish'),
  Portuguese: _TL_('Portuguese'),
  Romanian: _TL_('Romanian'),
  Russian: _TL_('Russian'),
  Serbian: _TL_('Serbian'),
  SimplifiedChinese: _TL_('Simplified Chinese'),
  Slovak: _TL_('Slovak'),
  Slovenian: _TL_('Slovenian'),
  Spanish: _TL_('Spanish'),
  Swedish: _TL_('Swedish'),
  TraditionalChinese: _TL_('Traditional Chinese'),
  Turkish: _TL_('Turkish'),
  Hebrew: _TL_('Hebrew'),
  Hindi: _TL_('Hindi'),
  Malay: _TL_('Malay'),
  Thai: _TL_('Thai'),
  Indonesian: _TL_('Indonesian'),
  Tagalog: _TL_('Tagalog'),
  Vietnamese: _TL_('Vietnamese'),
};
